import {
  Block,
  Marker,
  Segment,
} from "@app/analytics/components/PlayerControls/types";

export const doesIntersectTimestamp = (
  obj: Block | Marker | Segment,
  timeInSeconds: number,
  offset = 0
) => {
  // markers are positioned such that their left side aligns with the start time, so the
  // offset only needs to apply to the right side (i.e., end time)
  return (
    obj.startTime <= timeInSeconds && obj.endTime >= timeInSeconds - offset
  );
};

const doesIntersectTimeFrame = (
  obj: Block | Marker | Segment,
  start: number,
  end: number
) => !(obj.endTime < start || obj.startTime > end);

export const getIntersectingAnnotationsFromTimestamp = (
  timeInSeconds: number,
  blocks: Block[],
  markers: Marker[],
  segments: Segment[],
  markerOffset: number
) => {
  const intersectingBlocks = blocks.filter((b) =>
    doesIntersectTimestamp(b, timeInSeconds)
  );

  const intersectingMarkers = markers.filter((m) =>
    doesIntersectTimestamp(m, timeInSeconds, markerOffset)
  );

  const intersectingSegment = segments.find(
    (s) => s.label && doesIntersectTimestamp(s, timeInSeconds)
  );

  return {
    blocks: intersectingBlocks,
    markers: intersectingMarkers,
    segment: intersectingSegment,
  };
};

export const getIntersectingAnnotationsFromTimeFrame = (
  { start, end }: { start: number; end: number },
  blocks: Block[],
  markers: Marker[],
  segments: Segment[]
) => {
  const intersectingBlocks = blocks.filter((b) =>
    doesIntersectTimeFrame(b, start, end)
  );

  const intersectingMarkers = markers.filter((m) =>
    doesIntersectTimeFrame(m, start, end)
  );

  const intersectingSegment = segments.find(
    (s) => s.label && doesIntersectTimeFrame(s, start, end)
  );

  return {
    blocks: intersectingBlocks,
    markers: intersectingMarkers,
    segment: intersectingSegment,
  };
};
